import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  font-family: 'Share Tech Mono', monospace;
  font-size: 12px;
  color: rgba(255, 180, 50, 0.5);
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Value = styled.span`
  font-family: 'Share Tech Mono', monospace;
  font-size: 16px;
  color: #ffcc44;
  font-weight: 400;
  text-shadow: 0 0 15px rgba(255, 200, 50, 0.6);

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const Chain = styled.span`
  display: inline-block;
  background: linear-gradient(135deg, #f3ba2f 0%, #f0b90b 100%);
  color: #000;
  font-family: 'Rajdhani', sans-serif;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 3px;
  vertical-align: middle;

  @media (max-width: 768px) {
    font-size: 9px;
  }
`;
